import React from "react"
import { Col, Container, Row } from 'reactstrap';
import { T } from "../../traks"
import { Input, PhoneInp } from "../../c/Input"
import { RenderIf } from "../../helpers/RenderIf"

const ContactFields = ({ whistle, setWhistle }) => {
	return (<>
		<div className="ps-3 mt-5">
			<T>
				Please fill out contact information so the recipient can reach out.
			</T>
		</div>
		<div className="w-100 mt-3 d-flex flex-column flex-lg-row justify-content-center">
			<div className="w-100 me-3 mb-3 mb-lg-0">
				<Input
					type="text"
          id={"name"}
					placeholder={<T>name</T>}
					onChange={(name) => setWhistle({ ...whistle, name })}
				/>
			</div>
			<div className="w-100 ms-0 ms-lg-3 mb-3 mb-lg-0">
				<Input
					type="email"
          id={"email"}
					autocomplete="off"
					dataCy="email"
					placeholder={<T>email</T>}
					onChange={(email) => setWhistle({...whistle, email})}
				/>
			</div>
		</div>
		<div className="w_100_mobile d-flex justify-content-center">
			<div className="w-100 me-lg-3">
				<PhoneInp
					setPhoneNumber={(phone_number) => setWhistle({ ...whistle, phone_number })}
					className="mt-4"
				/>
			</div>
			<div className="w-100 ms-lg-3 d-none d-lg-flex" />
		</div>
	</>)
}

const AnonyChoiceBox = ({ isActive, onClick, img, children }) => {
	const activeClass = isActive ? "border border-2 primary-border-color" : ""
	return (
		<Col xs={12} lg={6} onClick={onClick}>
			<div className={`border_radius_10px bg-white cursor_pointer mb-3 ${activeClass}`}>
				<div className="d-flex flex-column justify-content-center align-items-center p-5">
					<img src={img} alt="anonymous icon" />
					<div className="d-flex align-items-center">
						<RenderIf condition={isActive}>
							<div >
								<img src="https://static.sibilus.eu/gfx/green-checkmark-icon-0.svg" alt="active-icon" />
							</div>
						</RenderIf>
						<div className={`${isActive ? "primary ": ""}fs-3 my-4 ms-3`}>
							{children[0]}
						</div>
					</div>
					<div>
						{children[1]}
					</div>
				</div>
			</div>
		</Col>

	)
}

const StepOne = ({ whistle, setWhistle, nextStep }) => {
	const buttonDisabled = !whistle.mode
		|| (
			whistle.mode === "nonanonymous"
			&& whistle.name === undefined
			&& whistle.email === undefined
			&& whistle.phone_number === undefined
		)

	return (
		<Container>
			<div className="d-flex flex-column justify-content-center px-2">
				<div className="px-4 my-4">
					<span className="txt_grey_3 font_10px text-start"><T>Step 1/2</T></span>
				</div>
				<div className="px-4 mb-4">
					<T>
						This is an 100% anonymous action. After submitting you will get an anonymous link where you always can check how the case is progressing.
					</T>
				</div>
				<Row className="px-4 pt-4">
					<AnonyChoiceBox
						onClick={() => setWhistle({ ...whistle, mode: "anonymous" })}
						img="https://static.sibilus.eu/gfx/anonymous-icon-0.svg"
						isActive={whistle.mode === "anonymous"}
					>
						<T>Anonymous</T>
						<T>
							Your administration or others in
							your organization will not see your text. Remember anonymous entries are not guaranteed handling and
							all your whistleblower rights are only guaranteed in confidential mode.
						</T>
					</AnonyChoiceBox>
					<AnonyChoiceBox
						onClick={() => setWhistle({ ...whistle, mode: "nonanonymous" })}
						img="https://static.sibilus.eu/gfx/non-anonymous-icon-0.svg"
						isActive={whistle.mode === "nonanonymous"}
					>
						<T>Non Anonymous</T>
						<T>
							A confidential entry will be treated with discretion, and only the assigned caseworkers will know your
							identity. Confidential mode ensures your rights as a whistleblower.
						</T>
					</AnonyChoiceBox>
					<RenderIf condition={whistle.mode === "nonanonymous"}>
						<ContactFields whistle={whistle} setWhistle={setWhistle} />
					</RenderIf>
				</Row>
				<div className="text-center mt-5">
					<button className={`btn btn_green ${buttonDisabled}`} disabled={buttonDisabled} onClick={() => nextStep()} >
						<span className="px-3"> <T>Continue</T> </span>
					</button>
				</div>
			</div>
		</Container>
	)
}

export { StepOne }
